<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoEditar">
            <div style="text-align: center;">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
		<div class="card" *ngIf="permissaoEditar">
			<form (keypress)="ocultarMensagem()" (ngSubmit)="f.form.valid && atualizar()" #f="ngForm" name="form"
				novalidate>
				<div class="flex justify-content-center" *ngIf="loading">
					<p-progressSpinner></p-progressSpinner>
				</div>
				<div *ngIf="messagemVisivel" class="mb-5">
					<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
				</div>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid" *ngIf="outraReceita">
						<div class="field col-12 md:col-3">
							<label htmlFor="planoContaEmpresa">Especificação</label>
							<p-dropdown [options]="planosContaEmpresa" optionLabel="descricao" placeholder="Selecione"
								name="planoContaEmpresa" ngModel #planoContaEmpresa="ngModel" [required]="true"
								[(ngModel)]="outraReceita.planoContaEmpresa">
							</p-dropdown>
						</div>
						<div class="field col-12 md:col-5">
							<label htmlFor="identificacao">Identificação</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								placeholder="Insira a Identificação" name="identificacao" ngModel
								#identificacao="ngModel" [(ngModel)]="outraReceita.identificacao" />
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="dataFluxo">Data da Receita</label>
							<p-calendar [readonlyInput]="true" [showIcon]="true" dateFormat="dd/mm/yy"
								[showButtonBar]="true" name="dataFluxo" ngModel #dataFluxo="ngModel"
								[(ngModel)]="outraReceita.dataFluxo">
							</p-calendar>
						</div>

						<div class="field col-12 md:col-2">
							<label htmlFor="valorFluxo">Valor da Receita</label>
							<p-inputNumber name="valorFluxo" ngModel #valorFluxo="ngModel" mode="currency"
								inputId="currency-brazil" currency="BRL" locale="pt-BR" [allowEmpty]="true"
								[required]="true" [(ngModel)]="outraReceita.valorFluxo">
							</p-inputNumber>
							<div *ngIf="valorFluxo.touched && valorFluxo.value <= 0" class="alerta">
								Insira o Valor
							</div>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="tipoPagamento">Tipo de Receita</label>
							<p-dropdown [options]="tiposPagamento" optionLabel="descricao" placeholder="Selecione"
								name="tipoPagamento" ngModel #tipoPagamento="ngModel" [required]="true"
								[(ngModel)]="outraReceita.tipoPagamento">
							</p-dropdown>
						</div>



					</div>
					<div class="p-fluid p-formgrid grid justify-content-between" *ngIf="!loading">
						<div class="col-12 md:col-4">
							<button *ngIf="!progressoRequisicao else exibirBotaoFalso" type="submit" pButton
								icon="pi pi-check" label="Atualizar"
								class="p-button-outlined p-button-success md:w-9rem"
								[disabled]="!f.valid || (outraReceita?.valorFluxo ?? 0)  <= 0">
							</button>
							<ng-template #exibirBotaoFalso>
								<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Atualizar"
									class="p-button-outlined p-button-success md:w-9rem" disabled>
								</button>
							</ng-template>
						</div>
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/outras-receitas"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>